<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded1"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">For my darling Sary.</span></span></p>
<p class="Dedication-ded"><span class="ePub-I">Thank you for gifting me the full spectrum of human emotion.</span></p>
<p class="Dedication-ded"><span class="ePub-I">Playing with you always in my heart, pinkie swear.</span></p>
<p class="Dedication-ded1"><span class="ePub-I">And to my parents,</span></p>
<p class="Dedication-ded"><span class="ePub-I">I have never felt more inspired, more supported, and more loved by any other souls alive.</span></p>
<p class="Dedication-ded"><span class="ePub-I">If only you could know the depths of my love and appreciation for you.</span></p>
<p class="Dedication-ded"><span class="ePub-I">It’s an honor to be your daughter.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?39d132c2